class SessionManager {
    constructor() {
        this.expiresAt = null
        this.warningThreshold = 5 * 60 * 1000 // 5 minutes before expiry
        this.activeSessionKey = 'wasActiveThisSession'
        this.sessionExpiryKey = 'sessionExpiresAt'
    }

    updateExpiration(expiresAt) {
        this.expiresAt = expiresAt
        localStorage.setItem(this.sessionExpiryKey, this.expiresAt)
    }

    getExpiration() {
        if (!this.expiresAt) {
            const stored = localStorage.getItem(this.sessionExpiryKey)
            this.expiresAt = stored ? parseInt(stored) : null
        }
        return this.expiresAt
    }

    markActiveThisSession() {
        sessionStorage.setItem(this.activeSessionKey, 'true')
    }

    hasBeenActiveThisSession() {
        return sessionStorage.getItem(this.activeSessionKey) === 'true'
    }

    clearActiveFlag() {
        sessionStorage.removeItem(this.activeSessionKey)
    }

    isExpired() {
        const expiry = this.getExpiration()
        let expired = !expiry || Date.now() >= expiry
        // If the user has never been active this session, we consider the session not expired.
        if (!this.hasBeenActiveThisSession()) {
            this.clear()
            return false
        }
        return expired
    }

    getTimeRemaining() {
        const expiry = this.getExpiration()
        if (!expiry) return 0
        return Math.max(0, expiry - Date.now())
    }

    shouldWarn() {
        const remaining = this.getTimeRemaining()
        return remaining > 0 && remaining <= this.warningThreshold
    }

    clear() {
        this.expiresAt = null
        localStorage.removeItem(this.sessionExpiryKey)
        this.clearActiveFlag()
    }

    isEmpty() {
        return this.getExpiration() === null
    }
}

export const sessionManager = new SessionManager()
